// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2gtqG","right":"styles_right__1kE3Y"};